import { NgModule } from '@angular/core';

export const MOBILE_COMPONENT_MODULES_FOR_ROOT = [];

@NgModule({})
export class MobileRuntimeDynamicModule {}
